<template>
  <v-container v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-form ref="form" validation @input="checkValidate" class="ml-3">
      <h1 class="my-3">{{title}}</h1>

      <v-layout row class="elevation-1 white mb-4 pa-3">
        <v-flex xs12 lg8 md8>
          <div class="title"><span>Фактический адрес: </span><span class="font-weight-thin">{{factAddress}}</span></div>
          <div class="title mt-1"><span>Телефон: </span><span class="font-weight-thin">{{phone}}</span></div>
          <div class="title mt-1"><span>Маршрут: </span><span class="font-weight-thin">{{way.title}}</span></div>
        </v-flex>
      </v-layout>

      <p class="title">Расписание доставки</p>
      <v-layout row class="elevation-1 white mb-4 pa-3">
        <v-flex xs8 lg6 md6>
          <v-layout row>
            <div class="subheading font-weight-bold mb-3 mx-3" v-if="schedule.monday !== '' && schedule.monday !== null"><span>Понедельник: </span><span class="font-weight-thin">{{schedule.monday}}</span></div>
          </v-layout>
          <v-layout row>
            <div class="subheading font-weight-bold mb-3 mx-3" v-if="schedule.tuesday !== '' && schedule.tuesday !== null"><span>Вторник: </span><span class="font-weight-thin">{{schedule.tuesday}}</span></div>
          </v-layout>
          <v-layout row>
            <div class="subheading font-weight-bold mb-3 mx-3" v-if="schedule.wednesday !== '' && schedule.wednesday !== null"><span>Среда: </span><span class="font-weight-thin">{{schedule.wednesday}}</span></div>
          </v-layout>
          <v-layout row>
            <div class="subheading font-weight-bold mb-3 mx-3" v-if="schedule.thursday !== '' && schedule.thursday !== null"><span>Четверг: </span><span class="font-weight-thin">{{schedule.thursday}}</span></div>
          </v-layout>
          <v-layout row>
            <div class="subheading font-weight-bold mb-3 mx-3" v-if="schedule.friday !== '' && schedule.friday !== null"><span>Пятница: </span><span class="font-weight-thin">{{schedule.friday}}</span></div>
          </v-layout>
          <v-layout row>
            <div class="subheading font-weight-bold mb-3 mx-3" v-if="schedule.saturday !== '' && schedule.saturday !== null"><span>Суббота: </span><span class="font-weight-thin">{{schedule.saturday}}</span></div>
          </v-layout>
          <v-layout row>
            <div class="subheading font-weight-bold mb-3 mx-3" v-if="schedule.sunday !== '' && schedule.sunday !== null"><span>Воскресенье: </span><span class="font-weight-thin">{{schedule.sunday}}</span></div>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row class="mb-3">
        <v-flex xs12 lg8 md8>
          <p class="title">Точка на карте</p>
          <yandex-map
              :coords="coordinate !== null ? coordinate : [55, 35]"
              zoom="3"
              style="width: 100%; height: 400px;"
              @map-was-initialized="initMap"
          >
            <ymap-marker
                v-if="coordinate !== null"
                :marker-id="1"
                marker-type="placemark"
                :coords="coordinate"
            ></ymap-marker>
          </yandex-map>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 ma-0">
        <v-flex xs12 lg6 md6 v-if="pointStatus !== null ? pointStatus.id === 1 : false">
          <v-btn
              color="primary"
              class="ma-0"
              @click="onClickApprove"
          >
            Согласовать
          </v-btn>
        </v-flex>
      </v-layout>

    </v-form>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      breadcrumbs: [
        {name: 'Главная', link: '/'},
        {name: 'Заявки', link: '/points/request/logistics/list'}
      ],
      pageDataReady: {
        isReady: false,
        point: false
      },
      title: null,
      id: null,
      factAddress: null,
      phone: null,
      pointStatus: null,
      coordinate: null,
      schedule: {
        monday: null,
        tuesday: null,
        wednesday: null,
        thursday: null,
        friday: null,
        saturday: null,
        sunday: null
      },
      way: null,
      map: null
    }),
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.point) {
          return false
        }
        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      initMap (instance) {
        this.map = instance
        this.map.behaviors.disable('scrollZoom')
        this.mapZoomUpdate()
      },
      mapZoomUpdate () {
        if (this.map !== null && this.map.geoObjects.getBounds() !== null) {
          this.map.setBounds(this.map.geoObjects.getBounds())
          if (this.map.getZoom() > 18) {
            this.map.setZoom(18)
          }
        }
      },
      checkValidate () {
        this.valid = true
        return this.valid
      },
      async onClickApprove () {
        await this.$store.dispatch('logisticsApprovePoint', {id: this.id})
          .then((data) => {
            this.$router.push('/points/request/logistics/list')
          })
          .catch((e) => {
            console.log(e)
          })
      },
      onCreated () {
        this.$store.commit('setPageLoading', true)
        this.title = null
        this.map = null
        this.id = null
        this.factAddress = null
        this.phone = '+7'
        this.coordinate = null
        this.pointStatus = null
        this.way = {id: null, title: null}
        this.schedule = {
          monday: null,
          tuesday: null,
          wednesday: null,
          thursday: null,
          friday: null,
          saturday: null,
          sunday: null
        }

        if (~this.$router.currentRoute.path.indexOf('/points/logistics/single/')) {
          this.id = parseInt(this.$route.params.id)
        }

        this.$store.dispatch('getPointSingle', {id: this.id})
          .then(() => {
            this.pageDataReady.point = true
            this.pageDataStatus()
          })
      }
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      },
      pointSingle () {
        return this.$store.getters.pointSingle
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      },
      pointSingle (val) {
        if (this.pointSingle !== null) {
          this.title = this.pointSingle.title
          this.breadcrumbs = [
            {name: 'Главная', link: '/'},
            {name: 'Заявки', link: '/points/request/logistics/list'}
          ]
          this.breadcrumbs.push({name: this.pointSingle.title})
          this.factAddress = this.pointSingle.fact_address !== null ? this.pointSingle.fact_address : null
          this.phone = this.pointSingle.phone !== null ? this.pointSingle.phone : null
          this.pointStatus = this.pointSingle.point_status !== null ? this.pointSingle.point_status : null
          if (this.pointSingle.coordinate !== null) {
            this.coordinate = [this.pointSingle.coordinate.lat, this.pointSingle.coordinate.lng]
          }
          this.way = this.pointSingle.way !== null ? this.pointSingle.way : {id: null, title: null}

          if (typeof this.pointSingle.cargo_schedule !== 'undefined') {
            if (this.pointSingle.cargo_schedule !== null) {
              this.schedule = {
                monday: this.pointSingle.cargo_schedule.monday !== '' ? this.pointSingle.cargo_schedule.monday : null,
                tuesday: this.pointSingle.cargo_schedule.tuesday !== '' ? this.pointSingle.cargo_schedule.tuesday : null,
                wednesday: this.pointSingle.cargo_schedule.wednesday !== '' ? this.pointSingle.cargo_schedule.wednesday : null,
                thursday: this.pointSingle.cargo_schedule.thursday !== '' ? this.pointSingle.cargo_schedule.thursday : null,
                friday: this.pointSingle.cargo_schedule.friday !== '' ? this.pointSingle.cargo_schedule.friday : null,
                saturday: this.pointSingle.cargo_schedule.saturday !== '' ? this.pointSingle.cargo_schedule.saturday : null,
                sunday: this.pointSingle.cargo_schedule.sunday !== '' ? this.pointSingle.cargo_schedule.sunday : null
              }
            } else {
              this.schedule = {
                monday: null,
                tuesday: null,
                wednesday: null,
                thursday: null,
                friday: null,
                saturday: null,
                sunday: null
              }
            }
          }
          this.$store.commit('setPageTitle', this.title)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Points/PointLogisticsSingle.vue